import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { USE_ALT_TOKEN } from '../constants/alt-token-http-context';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const useAltToken = req.context.get(USE_ALT_TOKEN);

		const token = useAltToken
			? localStorage.getItem('chatToken')
			: localStorage.getItem('token');

		const cloned = req.clone({
			setHeaders: {
				Authorization: `Bearer ${token}`
			}
		});

		return next.handle(cloned);
	}
}
